import { useQuery } from '@gogame/query';

import { loadCustomMetric } from 'scenes/Trackers/Tracker/sources/metrics';

import { loadCustomMetric as queryKey } from './queryKeyFactory';

export const useLoadCustomMetric = (id) => {
  return useQuery(queryKey(id), (_, { signal }) =>
    loadCustomMetric({ id }, { signal })
  );
};
